// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"T2-z","displaySixCardTiles":"U2-z"};